let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("840Ej")).then(() => parcelRequire('kn4iW'));